export type CommunityDisplayStatus = 'Voting' | 'Selected';

export interface CommunityIdeaStatusInput {
	status: string;
	isAdopted?: boolean;
	navigableTopicSlug?: string | null;
}

/** The public UI never exposes raw workflow states. */
export function displayStatus(idea: CommunityIdeaStatusInput): CommunityDisplayStatus {
	return idea.isAdopted ? 'Selected' : 'Voting';
}

export function isVotable(idea: CommunityIdeaStatusInput): boolean {
	return displayStatus(idea) === 'Voting' && idea.status === 'voting';
}

export function canShowViewTopic(idea: CommunityIdeaStatusInput): boolean {
	return displayStatus(idea) === 'Selected' && Boolean(idea.navigableTopicSlug?.trim());
}
